import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const AdvertiseBanner = () => (
  <section id="advertise-banner" data-testid="advertise-banner" className="relative py-8 md:py-10">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="relative overflow-hidden rounded-3xl p-8 md:p-14 border border-white/10"
        style={{
          background:
            "linear-gradient(135deg, #22D3EE 0%, #4F46E5 45%, #6B21D9 100%)",
        }}
      >
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/10 blur-3xl" />
        <div className="relative max-w-2xl">
          <div className="text-sm md:text-base text-white/80 mb-3">
            Put your brand in front of the right audience at the right time.
          </div>
          <h3 className="font-display text-3xl md:text-5xl font-extrabold text-white leading-tight">
            Nema TV delivers targeted advertising across streaming devices
            worldwide.
          </h3>
          <div className="mt-6 text-white/90 font-semibold">
            Get Started — Advertise With Us
          </div>
          <Link
            to="/advertise"
            data-testid="advertise-banner-cta"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-white text-[#05030A] px-6 py-3 text-sm font-semibold hover:bg-white/90 transition-colors"
          >
            Get Started
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);

export default AdvertiseBanner;
